module.exports = __webpack_public_path__ + "static/img/image080.7ed34a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image080.png
// module id = rGdi
// module chunks = 1